import React, { useMemo } from 'react';
import Image from 'next/image';
import style from './FacebookShareButton.module.scss';

const ICON_SIZE = 20;

export const FACEBOOK_URL = 'https://facebook.com/sharer';

export const generateFacebookSharerUrl = ({
  currentUrl,
  title,
}: {
  currentUrl: string;
  title: string;
}) => {
  const intentSearchParams = new URLSearchParams();
  intentSearchParams.append('u', currentUrl);
  intentSearchParams.append('quote', title);
  return `${FACEBOOK_URL}?${intentSearchParams.toString()}`;
};

interface Props {
  fullUrl: string;
  title: string;
}

const FacebookShareButton: React.FC<Props> = ({ fullUrl, title }) => {
  const { facebookUrl } = useMemo(() => {
    if (fullUrl.length > 0 && title) {
      const fullUrlAsURL = new URL(fullUrl);
      const { href } = fullUrlAsURL;
      return {
        facebookUrl: generateFacebookSharerUrl({ currentUrl: href, title }),
      };
    }

    return { facebookUrl: '' };
  }, [fullUrl, title]);

  return (
    <div className={style.container}>
      <a className={style.button} href={facebookUrl} target="_blank" rel="noreferrer">
        <div className={style['icon-container']}>
          <Image
            alt="Facebook"
            src="/static/images/social/facebook_icon_blue.png"
            width={ICON_SIZE}
            height={ICON_SIZE}
            loading="lazy"
          />
        </div>
        <span className={style.text}>シェア</span>
      </a>
    </div>
  );
};

export default FacebookShareButton;
